import { InjectedTypes, InjectorOrderOptions } from "types/injector";

/**
 * Gets the list of items to inject, in order.
 * This is a function so we could programmatically change what it returns in the future.
 * For example, we could return a different list if isMobile or for an AB test.
 */
export default function getInjectionOrder(
  isMobile: boolean,
  testVariant: string | null,
  injectOrderOptions: InjectorOrderOptions
): InjectedTypes[] {
  const {
    injectRecirc,
    injectBooksModule,
    injectMagPromo,
    isWebAppView,
  } = injectOrderOptions;

  // Webapp view gets a special treatment as we determine
  // whether its safe to inject ads.
  if (isWebAppView) {
    const injectionOrder = [];

    injectionOrder.push(InjectedTypes.Ad);

    if (injectRecirc) {
      injectionOrder.push(InjectedTypes.Recirc);
    }
    if (injectMagPromo) {
      injectionOrder.push(InjectedTypes.MagPromo);
    }
    if (injectBooksModule) {
      injectionOrder.push(InjectedTypes.Books);
    }
    return injectionOrder;
  }

  // if there are ads, space out special items with ads in between
  const injectionOrder = new Array(40).fill(InjectedTypes.Ad);
  let nonAds = 0;

  // only inject a recirc module if it doesn't already have a recirc module
  // and if it doesn't have a bento recirc module
  if (injectRecirc) {
    injectionOrder[2] = InjectedTypes.Recirc;
    nonAds++;
  }

  if (injectMagPromo) {
    injectionOrder[3 + nonAds] = InjectedTypes.MagPromo;
    nonAds++;
  }

  // Place the Books Module between the second and third ads
  if (injectBooksModule) {
    const placeAfterNumOfAds = injectMagPromo ? 4 : 3;
    injectionOrder[placeAfterNumOfAds + nonAds] = InjectedTypes.Books;
  }

  return injectionOrder;
}
